const initialState = 1;

const saveLastPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SAVE_LAST_PAGE':
                  return action.pageNumber;
            case 'RESET_LAST_PAGE':
            case 'LOGOUT_USER':
                  return 1;
            default:
                  break;
      }
      return state;
};
export default saveLastPaginationReducer;